/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    FrequentlyAskedQuestions: {
        id: 'cep.faqPage.FrequentlyAskedQuestions',
        defaultMessage: 'Frequently Asked Questions',
    },
    GoTo: {
        id: 'cep.faqPage.GoTo',
        defaultMessage: 'Go to...'
    },
    NoMatchingError: {
        id: 'cep.faqPage.NoMatchingError',
        defaultMessage: 'No matching results found',
    },
    TypeQuestion: {
        id: 'cep.faqPage.sections.TypeQuestion',
        defaultMessage: 'Start typing your question...',
    },
    General: {
        id: 'cep.faqPage.sections.General',
        defaultMessage: 'General'
    },
    Motor: {
        id: 'cep.faqPage.sections.Motor',
        defaultMessage: 'Motor'
    },
    Home: {
        id: 'cep.faqPage.sections.Home',
        defaultMessage: 'Home'
    },
    Health: {
        id: 'cep.faqPage.sections.Health',
        defaultMessage: 'Health'
    },
    Travel: {
        id: 'cep.faqPage.sections.Travel',
        defaultMessage: 'Travel'
    },
    GeneralQ1: {
        id: 'cep.faqPage.generalSection.topics.GeneralQ1',
        defaultMessage: 'How do I make a new claim?'
    },
    GeneralQ1A1: {
        id: 'cep.faqPage.generalSection.topics.GeneralQ1A1',
        defaultMessage: 'If you wish to make a claim or understand more about &lt;a href="https://www.saga.co.uk/mysaga/manage-policy/html/#/claim"&gt;how to make a claim&lt;/a&gt;, please visit our How to make a claim section for more information.'
    },
    GeneralQ2: {
        id: 'cep.faqPage.generalSection.topics.GeneralQ2',
        defaultMessage: 'How do I access my policy documents?'
    },
    GeneralQ2A1: {
        id: 'cep.faqPage.generalSection.topics.GeneralQ2A1',
        defaultMessage: 'You can access your policy documents in the &lt;a href="https://www.saga.co.uk/mysaga/manage-policy/html/#/documents"&gt;Documents&lt;/a&gt; section of MySaga. You can also request copies of these documents by post. If the documents don\'t arrive, or if you previously asked for an alternative format like large print, audio or braille and this isn\'t provided, please give us a call on {phoneNumber} (for Home Insurance) or {phoneNumber2} (for Motor Insurance), or contact us using the Chat button on our website.'
    },
    GeneralQ3: {
        id: 'cep.faqPage.generalSection.topics.GeneralQ3',
        defaultMessage: 'How do I view and update my payment details?'
    },
    GeneralQ3A1: {
        id: 'cep.faqPage.generalSection.topics.GeneralQ3A1',
        defaultMessage: 'If you need to view your payment schedule and update your payment details for your home and motor policies, please visit the &lt;a href="/billing-summary"&gt;Payments&lt;/a&gt; section.'
    },
    GeneralQ4: {
        id: 'cep.faqPage.generalSection.topics.GeneralQ4',
        defaultMessage: 'Can I make an overdue payment online?'
    },
    GeneralQ4A1: {
        id: 'cep.faqPage.generalSection.topics.GeneralQ4A1',
        defaultMessage: 'Yes, you can make an overdue payment for home and motor policies on the &lt;a href="/billing-summary"&gt;Payments&lt;/a&gt; section of MySaga.'
    },
    GeneralQ5: {
        id: 'cep.faqPage.generalSection.topics.GeneralQ5',
        defaultMessage: 'How do I renew my policy?'
    },
    GeneralQ5A1: {
        id: 'cep.faqPage.generalSection.topics.GeneralQ5A1',
        defaultMessage: 'You will be sent a renewal invitation at least 21 days before your renewal date. Your renewal invitation will then also be available for you to review and renew for home and motor policies on MySaga. If you pay by Direct Debit or set up a continuous payment when you took out your policy, don\'t worry we will automatically renew it for you.'
    },
    GeneralQ6: {
        id: 'cep.faqPage.generalSection.topics.GeneralQ6',
        defaultMessage: 'What policy changes can I make on MySaga?'
    },
    GeneralQ6A1: {
        id: 'cep.faqPage.generalSection.topics.GeneralQ6A1',
        defaultMessage: 'For your motor policies you can change your vehicle, change your registration, edit your mileage, vehicle use, and modifications, add or remove drivers to your policy and amend your additional cover levels.'
    },
    GeneralQ6A2: {
        id: 'cep.faqPage.generalSection.topics.GeneralQ6A2',
        defaultMessage: 'We\'re working hard to enable online changes to our other products in the future. For now, if you need to make a change to another type of policy, our friendly customer services team will be happy to help. Please see our &lt;a href="https://www.saga.co.uk/contact-us/insurance"&gt;Contact us&lt;/a&gt; section for more information.'
    },
    GeneralQ7: {
        id: 'cep.faqPage.generalSection.topics.GeneralQ7',
        defaultMessage: 'Can I make temporary policy changes on MySaga?'
    },
    GeneralQ7A1: {
        id: 'cep.faqPage.generalSection.topics.GeneralQ7A1',
        defaultMessage: 'Sorry we\'re currently unable to make temporary changes online to your policies. If you need to make a temporary change to your policy, our friendly customer services team will be happy to help. Please see our &lt;a href="https://www.saga.co.uk/contact-us/insurance"&gt;contact us&lt;/a&gt; section for more information.'
    },
    GeneralQ8: {
        id: 'cep.faqPage.generalSection.topics.GeneralQ8',
        defaultMessage: 'Why does MySaga timeout?'
    },
    GeneralQ8A1: {
        id: 'cep.faqPage.generalSection.topics.GeneralQ8A1',
        defaultMessage: 'MySaga will automatically time out after 30 minutes of inactivity in order to protect your data, in case you forgot to logout manually before leaving MySaga.'
    },
    GeneralQ9: {
        id: 'cep.faqPage.generalSection.topics.GeneralQ9',
        defaultMessage: 'How do I make a complaint?'
    },
    GeneralQ9A1: {
        id: 'cep.faqPage.generalSection.topics.GeneralQ9A1',
        defaultMessage: 'At Saga, we strive to ensure that our customers are treated fairly. If you are dissatisfied with a service or product we have provided, we will take your concerns very seriously. It is therefore important to us that our process for handling your concerns is clear and transparent and that you are kept fully aware of how your complaint is progressing.'
    },
    GeneralQ9A2: {
        id: 'cep.faqPage.generalSection.topics.GeneralQ9A2',
        defaultMessage: 'For more information, and to make a complaint, please &lt;a href="https://www.saga.co.uk/making-a-complaint"&gt;visit our complaints page&lt;/a&gt;.'
    },
    GeneralQ10: {
        id: 'cep.faqPage.generalSection.topics.GeneralQ10',
        defaultMessage: 'What is a policy excess?'
    },
    GeneralQ10A1: {
        id: 'cep.faqPage.generalSection.topics.GeneralQ10A1',
        defaultMessage: 'A policy excess is the amount of money you contribute towards the cost of a claim, for example, if your excess is £100, you will pay the first £100 towards the cost of the claim.'
    },
    MotorQ1: {
        id: 'cep.faqPage.generalSection.topics.MotorQ1',
        defaultMessage: 'How do I change my vehicle?'
    },
    MotorQ1A1: {
        id: 'cep.faqPage.generalSection.topics.MotorQ1A1',
        defaultMessage: 'You can change your vehicle by selecting your policy in the &lt;a href="https://www.saga.co.uk/mysaga/manage-policy/html/#/endorsement"&gt;amend policy page&lt;/a&gt;.'
    },
    MotorQ1A2: {
        id: 'cep.faqPage.generalSection.topics.MotorQ1A2',
        defaultMessage: 'You will need to provide the following:'
    },
    MotorQ1A3: {
        id: 'cep.faqPage.generalSection.topics.MotorQ1A3',
        defaultMessage: 'Reg number'
    },
    MotorQ1A4: {
        id: 'cep.faqPage.generalSection.topics.MotorQ1A4',
        defaultMessage: 'Make/Model/Description'
    },
    MotorQ1A5: {
        id: 'cep.faqPage.generalSection.topics.MotorQ1A5',
        defaultMessage: 'Engine size (cc)'
    },
    MotorQ1A6: {
        id: 'cep.faqPage.generalSection.topics.MotorQ1A6',
        defaultMessage: 'Year of manufacture'
    },
    MotorQ1A7: {
        id: 'cep.faqPage.generalSection.topics.MotorQ1A7',
        defaultMessage: 'Vehicle value'
    },
    MotorQ1A8: {
        id: 'cep.faqPage.generalSection.topics.MotorQ1A8',
        defaultMessage: 'Any modifications'
    },
    MotorQ1A9: {
        id: 'cep.faqPage.generalSection.topics.MotorQ1A9',
        defaultMessage: 'Where the vehicle is kept overnight.'
    },
    MotorQ1A10: {
        id: 'cep.faqPage.generalSection.topics.MotorQ1A10',
        defaultMessage: 'You will also have the opportunity to check the level of cover needed and that the annual mileage is appropriate for your everyday needs.'
    },
    MotorQ1A11: {
        id: 'cep.faqPage.generalSection.topics.MotorQ1A11',
        defaultMessage: 'If you have Saga Breakdown Assistance, we\'ll update this too so this can be applied to the new car.'
    },
    MotorQ1A12: {
        id: 'cep.faqPage.generalSection.topics.MotorQ1A12',
        defaultMessage: 'We won\'t charge you an admin fee if you change your car but the price of your insurance may change.'
    },
    MotorQ1A13: {
        id: 'cep.faqPage.generalSection.topics.MotorQ1A13',
        defaultMessage: 'Don\'t forget that when you change your car you\'ll need to tax it before you can legally drive it on the road. You can &lt;a href="https://www.gov.uk/vehicle-tax"&gt;do this online&lt;/a&gt; or at the Post Office. You\'ll need to tax your car even if you don\'t have to pay anything because you or your vehicle is exempt.'
    },
    MotorQ2: {
        id: 'cep.faqPage.generalSection.topics.MotorQ2',
        defaultMessage: 'How many drivers can I add to my Motor policy?'
    },
    MotorQ2A1: {
        id: 'cep.faqPage.generalSection.topics.MotorQ2A1',
        defaultMessage: 'In addition to the policy holder, you can add up to a maximum of 3 additional named drivers to your Motor policy by visiting the &lt;a href="https://www.saga.co.uk/mysaga/manage-policy/html/#/endorsement"&gt;Change my policy&lt;/a&gt; section.'
    },
    MotorQ3: {
        id: 'cep.faqPage.generalSection.topics.MotorQ3',
        defaultMessage: 'Can I add or change my cover, such as additional add-ons, voluntary excess or vehicle usage, mileage and modifications?'
    },
    MotorQ3A1: {
        id: 'cep.faqPage.generalSection.topics.MotorQ3A1',
        defaultMessage: 'You can amend the set-up of your cover by visiting the &lt;a href="https://www.saga.co.uk/mysaga/manage-policy/html/#/endorsement"&gt;Change my Policy&lt;/a&gt; section'
    },
    MotorQ4: {
        id: 'cep.faqPage.generalSection.topics.MotorQ4',
        defaultMessage: 'How do I change my address on my car insurance?'
    },
    MotorQ4A1: {
        id: 'cep.faqPage.generalSection.topics.MotorQ4A1',
        defaultMessage: 'If you need to change the address on your policy, please call us on {phoneNumber} and a member of our customer service team will be happy to help. Please have the following to hand when you call:'
    },
    MotorQ4A2: {
        id: 'cep.faqPage.generalSection.topics.MotorQ4A2',
        defaultMessage: 'The new address'
    },
    MotorQ4A3: {
        id: 'cep.faqPage.generalSection.topics.MotorQ4A3',
        defaultMessage: 'Where the vehicle is usually kept overnight'
    },
    MotorQ4A4: {
        id: 'cep.faqPage.generalSection.topics.MotorQ4A4',
        defaultMessage: 'Confirmation that cover level and mileage is still adequate. &lt;br/&gt;Adjustments such as change of address can affect your premium price.'
    },
    MotorQ5: {
        id: 'cep.faqPage.generalSection.topics.MotorQ5',
        defaultMessage: 'Am I covered to drive in the EU?'
    },
    MotorQ5A1: {
        id: 'cep.faqPage.generalSection.topics.MotorQ5A1',
        defaultMessage: 'Yes, you and any drivers named on the policy are. Both Saga Select and Saga Plus include cover for driving in EU countries as standard for an unlimited amount of time. Saga Standard includes cover to drive in the EU for up to 90 days in any policy year. We also include some other countries - &lt;a href="https://www.saga.co.uk/car-insurance/eu-cover#anchor_Whereiscovered"&gt;check which countries are covered&lt;/a&gt;.'
    },
    MotorQ5A2: {
        id: 'cep.faqPage.generalSection.topics.MotorQ5A2',
        defaultMessage: 'For most countries we cover, you don\'t need a green card anymore.'
    },
    MotorQ5A3: {
        id: 'cep.faqPage.generalSection.topics.MotorQ5A3',
        defaultMessage: 'Find out more about  &lt;a href="https://www.saga.co.uk/car-insurance/eu-cover"&gt;driving in Europe&lt;/a&gt;.'
    },
    MotorQ6: {
        id: 'cep.faqPage.generalSection.topics.MotorQ6',
        defaultMessage: 'What is your 3-year fixed price?'
    },
    MotorQ6A1: {
        id: 'cep.faqPage.generalSection.topics.MotorQ6A1',
        defaultMessage: 'Our flagship Saga Plus cover level comes with a 3-year fixed price. This means you get a price that won\'t go up for three years if nothing changes and the freedom to leave any time you like during the policy year with no cancellation fee. And if you make any mid-term changes like getting a new car or reducing your mileage, you won\'t be charged an admin fee. If the change affects your policy premium, we\'ll fix that new price for the remainder of the 3 years.'
    },
    MotorQ6A2: {
        id: 'cep.faqPage.generalSection.topics.MotorQ6A2',
        defaultMessage: 'Read all the &lt;a href="https://www.saga.co.uk/car-insurance/3-year-fixed-price#anchor_Termsandconditions"&gt;terms and conditions&lt;/a&gt; and find out more about our 3-year fixed price.'
    },
    MotorQ7: {
        id: 'cep.faqPage.generalSection.topics.MotorQ7',
        defaultMessage: 'Am I covered to drive other vehicles?'
    },
    MotorQ7A1: {
        id: 'cep.faqPage.generalSection.topics.MotorQ7A1',
        defaultMessage: 'Yes, you can drive a car that you don\'t own or that isn\'t insured by you or your spouse or partner, but only on a third-party basis.'
    },
    MotorQ7A2: {
        id: 'cep.faqPage.generalSection.topics.MotorQ7A2',
        defaultMessage: 'Third-party is the most basic level of car insurance, and means that if you have an accident that\'s your fault, your insurance will only cover the cost of repairing the other person\'s car and their medical expenses. Damage to the car you\'re driving or any injuries to you won\'t be covered.'
    },
    MotorQ7A3: {
        id: 'cep.faqPage.generalSection.topics.MotorQ7A3',
        defaultMessage: 'You\'ll also need to have the permission of the car\'s owner to drive it, and it must be insured in its own right.'
    },
    MotorQ7A4: {
        id: 'cep.faqPage.generalSection.topics.MotorQ7A4',
        defaultMessage: 'It\'s worth checking your Policy Schedule for any endorsements, as exclusions may apply due to certain occupations.'
    },
    MotorQ8: {
        id: 'cep.faqPage.generalSection.topics.MotorQ8',
        defaultMessage: 'Do I need to tell you if I\'ve been convicted of a crime?'
    },
    MotorQ8A1: {
        id: 'cep.faqPage.generalSection.topics.MotorQ8A1',
        defaultMessage: 'You must tell us about any driving offences you\'ve been convicted of in the last five years (this also applies to anyone named on your policy). This includes fixed penalty notices for offences like speeding, driving without due care, and drug or alcohol-related convictions. You\'ll need to give us the date of the conviction and the conviction code - you can find these on the &lt;a href="https://www.gov.uk/penalty-points-endorsements/endorsement-codes-and-penalty-points"&gt;gov.uk website&lt;/a&gt;. Please give us a call on {phoneNumber} if you need to do this.'
    },
    MotorQ8A2: {
        id: 'cep.faqPage.generalSection.topics.MotorQ8A2',
        defaultMessage: 'If you\'ve been caught speeding and since been on a speed awareness course, you don\'t have to declare a conviction. You also don\'t need to tell us about parking tickets (also known as penalty charge notices).'
    },
    MotorQ9: {
        id: 'cep.faqPage.generalSection.topics.MotorQ9',
        defaultMessage: 'Does Saga cover classic cars/imported vehicles?'
    },
    MotorQ9A1: {
        id: 'cep.faqPage.generalSection.topics.MotorQ9A1',
        defaultMessage: 'It is possible to insure an imported vehicle as long as the car meets our specific criteria:'
    },
    MotorQ9A2: {
        id: 'cep.faqPage.generalSection.topics.MotorQ9A2',
        defaultMessage: 'The vehicle must be imported from Europe'
    },
    MotorQ9A3: {
        id: 'cep.faqPage.generalSection.topics.MotorQ9A3',
        defaultMessage: 'It must have been built to a UK or EU specification and have been modified for use in left-hand drive traffic'
    },
    MotorQ9A4: {
        id: 'cep.faqPage.generalSection.topics.MotorQ9A4',
        defaultMessage: 'The vehicle must appear on the ABI vehicle listing&lt;br/&gt;&lt;br/&gt;Whilst we do not offer a specific classic car policy with an agreed value, we do not have a vehicle age limit and may be able to insure a classic car under our normal policy terms. If you have any questions about insuring an imported or classic car, please call us on {phoneNumber} and one of our Customer Service advisers will be happy to help.'
    },
    MotorQ10: {
        id: 'cep.faqPage.generalSection.topics.MotorQ10',
        defaultMessage: 'Do you need to know about my health issues or medical condition?'
    },
    MotorQ10A1: {
        id: 'cep.faqPage.generalSection.topics.MotorQ10A1',
        defaultMessage: 'We do not need to know about any health issue or medical condition as long as the DVLA have not restricted or removed your driving licence.'
    },
    MotorQ11: {
        id: 'cep.faqPage.generalSection.topics.MotorQ11',
        defaultMessage: 'Does Saga offer temporary cover?'
    },
    MotorQ11A1: {
        id: 'cep.faqPage.generalSection.topics.MotorQ11A1',
        defaultMessage: 'Yes, subject to acceptance criteria. You can add a temporary driver or vehicle to your policy for up to a total of 28 days. The additional vehicle must be legally owned. Additional drivers can also be added on a permanent basis if this is more suitable. Please give us a call on {phoneNumber} and one of our Customer Service advisers will be happy to help.'
    },
    MotorQ12: {
        id: 'cep.faqPage.generalSection.topics.MotorQ12',
        defaultMessage: 'Is voluntary work covered?'
    },
    MotorQ12A1: {
        id: 'cep.faqPage.generalSection.topics.MotorQ12A1',
        defaultMessage: 'Yes, while your vehicle is being used for voluntary work in connection with a UK-registered voluntary or charitable organisation as long as you receive no financial gain and it is voluntary.'
    },
    MotorQ13: {
        id: 'cep.faqPage.generalSection.topics.MotorQ13',
        defaultMessage: 'Is my windscreen covered if it\'s broken or damaged?'
    },
    MotorQ13A1: {
        id: 'cep.faqPage.generalSection.topics.MotorQ13A1',
        defaultMessage: 'Yes, we include windscreen cover with Saga Plus, Saga Select and Saga Standard. And if you claim for this it won\'t affect your No Claim Discount.'
    },
    MotorQ13A2: {
        id: 'cep.faqPage.generalSection.topics.MotorQ13A2',
        defaultMessage: 'With Saga Plus and Saga Select, as long as you use one of our approved repairers and they don\'t need to replace your windscreen, you won\'t even have to pay for it (Saga Standard has a £25 excess for repairs).'
    },
    MotorQ13A3: {
        id: 'cep.faqPage.generalSection.topics.MotorQ13A3',
        defaultMessage: 'If your windscreen does need replacing, and you use a Saga approved repairer, you\'ll have to pay a £75 excess (£100 excess with Saga Standard).'
    },
    MotorQ13A4: {
        id: 'cep.faqPage.generalSection.topics.MotorQ13A4',
        defaultMessage: 'Different T&amp;Cs apply if you use someone we haven\'t approved - you can find more about this in the \'Broken glass\' section of your &lt;a href="https://www.saga.co.uk/insurance/car-insurance/policy-books"&gt;policy book&lt;/a&gt;.'
    },
    MotorQ14: {
        id: 'cep.faqPage.generalSection.topics.MotorQ14',
        defaultMessage: 'Am I covered if my car\'s vandalised?'
    },
    MotorQ14A1: {
        id: 'cep.faqPage.generalSection.topics.MotorQ14A1',
        defaultMessage: 'Yes, you are. Our Saga Plus and Saga Select Comprehensive policies include cover for vandalism as standard. And any valid claims you make for vandalism damage won\'t affect your No Claim Discount. Saga Standard policies will cover you for the damage caused by vandalism, but this may affect your No Claim Discount and could be subject to a policy excess.'
    },
    MotorQ15: {
        id: 'cep.faqPage.generalSection.topics.MotorQ15',
        defaultMessage: 'What happens if I\'m hit by an uninsured driver?'
    },
    MotorQ15A1: {
        id: 'cep.faqPage.generalSection.topics.MotorQ15A1',
        defaultMessage: 'Our Comprehensive policies include cover for this as standard. So if your car\'s hit by someone who isn\'t insured, as long as it isn\'t your fault (and you have the other car\'s reg and the accident details), we\'ll refund any excess you\'ve paid. And it won\'t affect your No Claim Discount.'
    },
    MotorQ16: {
        id: 'cep.faqPage.generalSection.topics.MotorQ16',
        defaultMessage: 'Does Saga offer multicar insurance?'
    },
    MotorQ16A1: {
        id: 'cep.faqPage.generalSection.topics.MotorQ16A1',
        defaultMessage: 'If you already hold an existing motor policy with us, anyone in your household who has a car may benefit from our Multi Car Discount as long as they\'re 50 or over. The different vehicles need to be insured at the same address, but do not need to be insured by the same person.'
    },
    MotorQ16A2: {
        id: 'cep.faqPage.generalSection.topics.MotorQ16A2',
        defaultMessage: 'You can keep all policies together in one MySaga account, or use separate accounts if you choose to set up the policies in different names. There will be separate renewal dates, and you\'ll earn No Claim Discount (NCD) on all vehicles individually.'
    },
    MotorQ16A3: {
        id: 'cep.faqPage.generalSection.topics.MotorQ16A3',
        defaultMessage: 'Call us on {phoneNumber} to see how much it\'ll cost. Or you can get a quote online.'
    },
    MotorQ17: {
        id: 'cep.faqPage.generalSection.topics.MotorQ17',
        defaultMessage: 'What is No Claim Discount?'
    },
    MotorQ17A1: {
        id: 'cep.faqPage.generalSection.topics.MotorQ17A1',
        defaultMessage: 'No Claim Discount (NCD) is earned by the policyholder on each individual vehicle that is insured under a policy. One years\' NCD is earned for each year you hold a policy without making a fault claim, in accordance with our current NCD scale.'
    },
    MotorQ18: {
        id: 'cep.faqPage.generalSection.topics.MotorQ18',
        defaultMessage: 'What documents would I have to submit as proof of my NCD and how can I prove this?'
    },
    MotorQ18A1: {
        id: 'cep.faqPage.generalSection.topics.MotorQ18A1',
        defaultMessage: 'If you have provided the details of your previous insurer, we will attempt to contact them to confirm your entitlement to a No Claim Discount (NCD). Please be aware that not all insurers will validate NCD over the phone. If we cannot confirm your NCD, we will write to you asking for written proof. Originals or photocopies are acceptable in the following forms:'
    },
    MotorQ18A2: {
        id: 'cep.faqPage.generalSection.topics.MotorQ18A2',
        defaultMessage: 'Previous insurer\'s renewal notice'
    },
    MotorQ18A3: {
        id: 'cep.faqPage.generalSection.topics.MotorQ18A3',
        defaultMessage: 'NCD letter or card'
    },
    MotorQ18A4: {
        id: 'cep.faqPage.generalSection.topics.MotorQ18A4',
        defaultMessage: 'Broker\'s proof.&lt;br/&gt; Written proof must clearly show names and dates.'
    },
    MotorQ18A5: {
        id: 'cep.faqPage.generalSection.topics.MotorQ18A5',
        defaultMessage: 'You can email your NCD directly to us at &lt;a href="mailto:ncdvalidation@saga.co.uk"&gt;ncdvalidation@saga.co.uk&lt;/a&gt; Alternatively, your proof of No Claim Discount can be sent to: Saga Services Limited, PO Box 253, Seaham DO, SR7 1BN'
    },
    MotorQ18A6: {
        id: 'cep.faqPage.generalSection.topics.MotorQ18A6',
        defaultMessage: 'You can contact our Customer Service team for further information on {phoneNumber}.'
    },
    MotorQ19: {
        id: 'cep.faqPage.generalSection.topics.MotorQ19',
        defaultMessage: 'Do my years spent driving a company car count towards NCD?'
    },
    MotorQ19A1: {
        id: 'cep.faqPage.generalSection.topics.MotorQ19A1',
        defaultMessage: 'If you have had the sole personal use of a company car (e.g. have had a car reserved for your own use both for work and for pleasure purposes) but have lost it due to retirement, change in position or due to changes in taxation laws, you will be allowed NCD in accordance with the number of claim free years immediately before the start date of your motor insurance policy. If this affects you please call us and speak to one of our Customer Service advisers on {phoneNumber}.'
    },
    MotorQ20: {
        id: 'cep.faqPage.generalSection.topics.MotorQ20',
        defaultMessage: 'How long is No Claim Discount valid for?'
    },
    MotorQ20A1: {
        id: 'cep.faqPage.generalSection.topics.MotorQ20A1',
        defaultMessage: 'Your NCD will be valid for two years after the end of your last policy, provided it is not being used on another policy.'
    },
    MotorQ21: {
        id: 'cep.faqPage.generalSection.topics.MotorQ21',
        defaultMessage: 'Can I use No Claim Discount earned outside the UK?'
    },
    MotorQ21A1: {
        id: 'cep.faqPage.generalSection.topics.MotorQ21A1',
        defaultMessage: 'Evidence received from any European Union member country is acceptable.'
    },
    MotorQ21A2: {
        id: 'cep.faqPage.generalSection.topics.MotorQ21A2',
        defaultMessage: 'No Claim Discount earned in any other country outside of the EU will only be considered if the insurer concerned is a branch of an established UK insurance company.'
    },
    MotorQ22: {
        id: 'cep.faqPage.generalSection.topics.MotorQ22',
        defaultMessage: 'Will you use official parts/repairers in the event of a claim?'
    },
    MotorQ22A1: {
        id: 'cep.faqPage.generalSection.topics.MotorQ22A1',
        defaultMessage: 'If the vehicle needs to be repaired our insurers have a nationwide network of partnership repairers.'
    },
    MotorQ22A2: {
        id: 'cep.faqPage.generalSection.topics.MotorQ22A2',
        defaultMessage: 'Partnership repairers ensure a high standard of service and provide high quality repair work, with a five year warranty. Their quality is constantly under review by our own team of engineers. However, if the vehicle is three years old or more and is outside the manufacturer\'s warranty period, we may decide to fit replacement parts which have not been made by the car\'s manufacturer but are considered of a similar standard or we may fit green parts.'
    },
    MotorQ23: {
        id: 'cep.faqPage.generalSection.topics.MotorQ23',
        defaultMessage: 'Will I get a courtesy car while my car is being repaired?'
    },
    MotorQ23A1: {
        id: 'cep.faqPage.generalSection.topics.MotorQ23A1',
        defaultMessage: 'You will get a guaranteed replacement car as standard if your car is being repaired by an approved repairer following an accident within the UK.'
    },
    MotorQ23A2: {
        id: 'cep.faqPage.generalSection.topics.MotorQ23A2',
        defaultMessage: 'Additionally, you can choose to add our replacement car extension cover to your policy. This will provide you with a replacement car if yours is stolen or written off in the UK - keeping you mobile and giving you time to find and purchase a new vehicle.'
    },
    MotorQ24: {
        id: 'cep.faqPage.generalSection.topics.MotorQ24',
        defaultMessage: 'How can I cancel my car insurance?'
    },
    MotorQ24A1: {
        id: 'cep.faqPage.generalSection.topics.MotorQ24A1',
        defaultMessage: 'If you would like to discuss cancelling your policy, please call us on {phoneNumber}.'
    },
    MotorQ24A2: {
        id: 'cep.faqPage.generalSection.topics.MotorQ24A2',
        defaultMessage: '&lt;b&gt;Cancellation - before the policy has started&lt;/b&gt;'
    },
    MotorQ24A3: {
        id: 'cep.faqPage.generalSection.topics.MotorQ24A3',
        defaultMessage: 'If you wish to cancel your policy before your cover has started, you will receive a full refund of any premium paid.'
    },
    MotorQ24A4: {
        id: 'cep.faqPage.generalSection.topics.MotorQ24A4',
        defaultMessage: '&lt;b&gt;Cancellation - within the first 14 days&lt;/b&gt;'
    },
    MotorQ24A5: {
        id: 'cep.faqPage.generalSection.topics.MotorQ24A5',
        defaultMessage: 'If you wish to cancel your policy within the first 14 days of getting your policy documents, and your cover has started, then you will receive a pro-rata refund of your premium based on the cover you have had. Once your policy has started, the Arrangement Fee will not be refunded. If you have a Saga Plus policy, no cancellation fee will be applied.'
    },
    MotorQ24A6: {
        id: 'cep.faqPage.generalSection.topics.MotorQ24A6',
        defaultMessage: '&lt;b&gt;Cancellation - after the first 14 days&lt;/b&gt;'
    },
    MotorQ24A7: {
        id: 'cep.faqPage.generalSection.topics.MotorQ24A7',
        defaultMessage: 'You can choose to cancel your policy at any time. You will receive a pro-rata refund of your premium based on the cover you have had, provided no claims have been made. Once your policy has started, the Arrangement Fee will not be refunded. If you have a Saga Standard or Saga Select policy, a £50 cancellation fee will be applied. If you have a Saga Plus policy, no cancellation fee will be applied.'
    },
    HomeQ1: {
        id: 'cep.faqPage.generalSection.topics.HomeQ1',
        defaultMessage: 'I need more than £100,000 cover for my contents or more than £1,000,000 for buildings - can you cover me?'
    },
    HomeQ1A1: {
        id: 'cep.faqPage.generalSection.topics.HomeQ1A1',
        defaultMessage: 'We no longer offer TailorMade Home Insurance, however, if you\'re looking for specialist high-value home insurance, we\'ve identified Hiscox home insurance as a good alternative to Saga TailorMade Home Insurance.'
    },
    HomeQ1A2: {
        id: 'cep.faqPage.generalSection.topics.HomeQ1A2',
        defaultMessage: 'Hiscox offers similarly high levels of cover, expertise and customer service, along with a UK-based claims team.'
    },
    HomeQ1A3: {
        id: 'cep.faqPage.generalSection.topics.HomeQ1A3',
        defaultMessage: 'For contact information, or if you are an existing customer, please visit our &lt;a href="https://www.saga.co.uk/contact-us/insurance"&gt;contact us page&lt;/a&gt;.'
    },
    HomeQ2: {
        id: 'cep.faqPage.generalSection.topics.HomeQ2',
        defaultMessage: 'What is your 3-year fixed price?'
    },
    HomeQ2A1: {
        id: 'cep.faqPage.generalSection.topics.HomeQ2A1',
        defaultMessage: 'Our flagship Saga Plus cover level comes with a 3-year fixed price. This means you get a price that won\'t go up for three years if nothing changes and the freedom to leave any time you like during the policy year with no cancellation fee. And if you make any mid-term changes like moving house you won\'t be charged an admin fee. If the change affects your policy premium, we\'ll fix that new price for the remainder of the 3 years.'
    },
    HomeQ2A2: {
        id: 'cep.faqPage.generalSection.topics.HomeQ2A2',
        defaultMessage: 'Read all the terms and conditions and find out more about our &lt;a href="https://www.saga.co.uk/car-insurance/3-year-fixed-price#anchor_Termsandconditions"&gt;3-year fixed price&lt;/a&gt;.'
    },
    HomeQ3: {
        id: 'cep.faqPage.generalSection.topics.HomeQ3',
        defaultMessage: 'What is Flood Re?'
    },
    HomeQ3A1: {
        id: 'cep.faqPage.generalSection.topics.HomeQ3A1',
        defaultMessage: 'Flood Re is a scheme developed by the government and insurance industry aimed at helping households that have the highest risk of flooding. It allows the insurer to pass the flood risk part of your insurance onto Flood Re. This means that home insurance is more widely available to those homes built before 2009 that have a high risk of flooding. For more information please visit our &lt;a href="https://www.saga.co.uk/insurance/home-insurance/flood-re"&gt;Flood Re&lt;/a&gt; page.'
    },
    HomeQ4: {
        id: 'cep.faqPage.generalSection.topics.HomeQ4',
        defaultMessage: 'What is new for old?'
    },
    HomeQ4A1: {
        id: 'cep.faqPage.generalSection.topics.HomeQ4A1',
        defaultMessage: 'With our new for old cover you have peace of mind that if an item is damaged beyond repair, we will replace it. For example, if your TV is knocked over and breaks, we will replace it with a brand new one or pay you the equivalent cost.'
    },
    HomeQ5: {
        id: 'cep.faqPage.generalSection.topics.HomeQ5',
        defaultMessage: 'How am I covered if I damage part of a matching pair or set?'
    },
    HomeQ5A1: {
        id: 'cep.faqPage.generalSection.topics.HomeQ5A1',
        defaultMessage: 'Under our Saga Plus cover level you are covered for damage to items that are part of a matching pair or set. For example, if a friend spills red wine on your sofa and it can\'t be cleaned or replaced to match the set, we will replace the whole suite. This feature is not available on our Saga Select cover level.'
    },
    HomeQ6: {
        id: 'cep.faqPage.generalSection.topics.HomeQ6',
        defaultMessage: 'What is Legal Expenses?'
    },
    HomeQ6A1: {
        id: 'cep.faqPage.generalSection.topics.HomeQ6A1',
        defaultMessage: 'Legal Expenses is an optional cover that can be added to your Saga Home Insurance policy at any time. It can provide up to £100,000 for legal costs in a range of scenarios, including property or contract disputes, personal injury, probate, and more.'
    },
    HomeQ6A2: {
        id: 'cep.faqPage.generalSection.topics.HomeQ6A2',
        defaultMessage: 'Our Legal Expenses option also includes an Online Safety Support Service. This means you can get advice, support and solutions for identity fraud, computer viruses and suspicious emails.'
    },
    HomeQ7: {
        id: 'cep.faqPage.generalSection.topics.HomeQ7',
        defaultMessage: 'What is accidental damage and am I covered?'
    },
    HomeQ7A1: {
        id: 'cep.faqPage.generalSection.topics.HomeQ7A1',
        defaultMessage: 'We understand that accidents around the home can happen at any time, which is why we offer optional accidental damage cover for our buildings insurance, for fixtures and fittings such as your kitchen units, bathroom suite and glass in your windows and doors. Optional accidental damage is also available for our contents insurance, which covers you for accidents at home like spillages on carpets, losing your glasses or dropping your laptop.'
    },
    HomeQ7A2: {
        id: 'cep.faqPage.generalSection.topics.HomeQ7A2',
        defaultMessage: 'Accidental damage is included as standard under our Saga Plus cover level. You can choose to add accidental damage to your Saga Select cover at any time by calling {phoneNumber}. With this included, you can feel safe knowing that cover is in place.'
    },
    HomeQ8: {
        id: 'cep.faqPage.generalSection.topics.HomeQ8',
        defaultMessage: 'What is Saga Home Emergency?'
    },
    HomeQ8A1: {
        id: 'cep.faqPage.generalSection.topics.HomeQ8A1',
        defaultMessage: 'Saga Home Emergency is an additional option which will cover you for a range of unexpected emergencies such as blocked drains, burst pipes, electrical failures, smashed windows and pest infestations. This cover provides unlimited call outs from a qualified tradesperson, up to three nights alternative accommodation while your home is being repaired and a 24/7 helpline so you can feel safe in the knowledge that we\'re here for you whenever you need us.'
    },
    HomeQ8A2: {
        id: 'cep.faqPage.generalSection.topics.HomeQ8A2',
        defaultMessage: 'Saga Home Emergency is administered by Inter Partner Assistance S.A. UK Branch and offers two different cover levels:'
    },
    HomeQ8A3: {
        id: 'cep.faqPage.generalSection.topics.HomeQ8A3',
        defaultMessage: '&lt;b&gt;Home Emergency&lt;/b&gt; - This level provides cover for a range of home emergencies relating to gas and electricity supply, water supply pipes, plumbing and drains.'
    },
    HomeQ8A4: {
        id: 'cep.faqPage.generalSection.topics.HomeQ8A4',
        defaultMessage: '&lt;b&gt;Home and Heating Emergency&lt;/b&gt; - This level adds further cover for a sudden and complete breakdown of the boiler, heating or hot water systems.&lt;br/&gt; You can add Saga Home Emergency to your policy at any time by calling {phoneNumber}.'
    },
    HomeQ9: {
        id: 'cep.faqPage.generalSection.topics.HomeQ9',
        defaultMessage: 'What is Personal Belongings Cover?'
    },
    HomeQ9A1: {
        id: 'cep.faqPage.generalSection.topics.HomeQ9A1',
        defaultMessage: 'Damaging your valuables can happen at any time which is why our Personal Belongings Cover protects your personal possessions anywhere in the world. You can choose to add cover up to £2,500, £5,000 or £10,000 per incident. Whether it\'s an iPad left on a train, dropping your mobile phone on the floor or having your camera stolen on holiday you can claim to cover the cost of a replacement. Personal Belongings Cover is included as standard in our Saga Plus cover level but can be added to your Saga Select policy at any time by calling {phoneNumber}.'
    },
    HomeQ10: {
        id: 'cep.faqPage.generalSection.topics.HomeQ10',
        defaultMessage: 'What is Garden Cover?'
    },
    HomeQ10A1: {
        id: 'cep.faqPage.generalSection.topics.HomeQ10A1',
        defaultMessage: 'Our Saga Select cover level includes garden cover up to £1,000 for loss or damage to your garden contents, including patio furniture, outdoor heaters and BBQs, as well as covering your plants, shrubs, trees and garden ornaments. If you choose our Saga Plus cover level, then cover is extended up to £5,000'
    },
    HomeQ11: {
        id: 'cep.faqPage.generalSection.topics.HomeQ11',
        defaultMessage: 'Do I need to inform you if I am making any alterations or renovations to my property?'
    },
    HomeQ11A1: {
        id: 'cep.faqPage.generalSection.topics.HomeQ11A1',
        defaultMessage: 'Yes, it is important that you inform us of any changes to your property, for example, an extension or adding a conservatory, so we can ensure you have the right level of cover in place whilst the alterations are ongoing.'
    },
    HomeQ12: {
        id: 'cep.faqPage.generalSection.topics.HomeQ12',
        defaultMessage: 'How do I make a change to my Home policy?'
    },
    HomeQ12A1: {
        id: 'cep.faqPage.generalSection.topics.HomeQ12A1',
        defaultMessage: 'If you need to make a change to your Home policy, our friendly customer services team will be happy to help. Please call our existing customer helpline on {phoneNumber}. Please refer to your policy documents as some changes may require you to pay an administration fee.'
    },
    HomeQ13: {
        id: 'cep.faqPage.generalSection.topics.HomeQ13',
        defaultMessage: 'How can I cancel my home insurance?'
    },
    HomeQ13A1: {
        id: 'cep.faqPage.generalSection.topics.HomeQ13A1',
        defaultMessage: 'If you would like to discuss cancelling your policy, please call us on {phoneNumber}.'
    },
    HomeQ13A2: {
        id: 'cep.faqPage.generalSection.topics.HomeQ13A2',
        defaultMessage: '&lt;b&gt;Cancellation - before the policy has started&lt;/b&gt;'
    },
    HomeQ13A3: {
        id: 'cep.faqPage.generalSection.topics.HomeQ13A3',
        defaultMessage: 'If you wish to cancel your policy before your cover has started, you will receive a full refund of any premium paid.'
    },
    HomeQ13A4: {
        id: 'cep.faqPage.generalSection.topics.HomeQ13A4',
        defaultMessage: '&lt;b&gt;Cancellation - within the first 14 days&lt;/b&gt;'
    },
    HomeQ13A5: {
        id: 'cep.faqPage.generalSection.topics.HomeQ13A5',
        defaultMessage: 'If you wish to cancel your policy within the first 14 days of getting your policy documents, and your cover has started, then you will receive a pro-rata refund of your premium based on the cover you have had. Once your policy has started, the Arrangement Fee will not be refunded.'
    },
    HomeQ13A6: {
        id: 'cep.faqPage.generalSection.topics.HomeQ13A6',
        defaultMessage: '&lt;b&gt;Cancellation - after the first 14 days&lt;/b&gt;'
    },
    HomeQ13A7: {
        id: 'cep.faqPage.generalSection.topics.HomeQ13A7',
        defaultMessage: 'You can choose to cancel your policy at any time. You will receive a pro-rata refund of your premium based on the cover you have had, provided no claims have been made. Once your policy has started, the Arrangement Fee will not be refunded. If you have a Saga Select policy, a £35 cancellation fee will be applied. If you have a Saga Plus policy, no cancellation fee will be applied.'
    },
    HealthQ1: {
        id: 'cep.faqPage.generalSection.topics.HealthQ1',
        defaultMessage: 'How do I make a claim?'
    },
    HealthQ1A1: {
        id: 'cep.faqPage.generalSection.topics.HealthQ1A1',
        defaultMessage: 'As soon as your GP gives you an open referral or refers you to a specialist, call our Claims Helpline on {phoneNumber} or you can contact us digitally by visiting &lt;a href="https://www.bupa.co.uk/"&gt;bupa.co.uk&lt;/a&gt; or download the MyBupa App.'
    },
    HealthQ1A2: {
        id: 'cep.faqPage.generalSection.topics.HealthQ1A2',
        defaultMessage: 'One of our advisers will be able to assist you regarding your cover and forward a claim form to you, if required.'
    },
    HealthQ1A3: {
        id: 'cep.faqPage.generalSection.topics.HealthQ1A3',
        defaultMessage: 'When you have received your treatment we usually make payment directly to your hospital or specialist so you do not have to pay any bills yourself.'
    },
    HealthQ1A4: {
        id: 'cep.faqPage.generalSection.topics.HealthQ1A4',
        defaultMessage: 'Visit &lt;a href="https://www.saga.co.uk/health-insurance/how-to-make-a-claim"&gt;how to make a claim&lt;/a&gt; to see a simple step by step guide.'
    },
    HealthQ2: {
        id: 'cep.faqPage.generalSection.topics.HealthQ2',
        defaultMessage: 'What happens if I receive NHS treatment?'
    },
    HealthQ2A1: {
        id: 'cep.faqPage.generalSection.topics.HealthQ2A1',
        defaultMessage: 'If you need to be admitted to an NHS hospital for a condition covered under your plan, your Saga HealthPlan will pay you £100 for every night you spend as an NHS inpatient, up to a maximum £2,000 every policy year.'
    },
    HealthQ2A2: {
        id: 'cep.faqPage.generalSection.topics.HealthQ2A2',
        defaultMessage: 'If you select our Super HealthPlan we will pay you £150 for every night you spend as an NHS inpatient, up to a maximum of £3,000 every policy year.'
    },
    HealthQ3: {
        id: 'cep.faqPage.generalSection.topics.HealthQ3',
        defaultMessage: 'What happens if I change my mind?'
    },
    HealthQ3A1: {
        id: 'cep.faqPage.generalSection.topics.HealthQ3A1',
        defaultMessage: 'You may cancel your policy by contacting Saga during the 14-day cooling-off period.'
    },
    HealthQ3A2: {
        id: 'cep.faqPage.generalSection.topics.HealthQ3A2',
        defaultMessage: 'The 14-day cooling-off period begins on either the start date or renewal date of the policy or the day that the policyholder receives the full policy terms and conditions, whichever is the later. The 14-day cooling-off period also applies from each renewal date. If the policy is cancelled during the 14-day cooling-off period we will provide a full refund providing a claim has not been made. If you have made a claim during the 14-day cooling-off period you will receive a pro-rata refund.'
    },
    HealthQ4: {
        id: 'cep.faqPage.generalSection.topics.HealthQ4',
        defaultMessage: 'How can I reduce my premium?'
    },
    HealthQ4A1: {
        id: 'cep.faqPage.generalSection.topics.HealthQ4A1',
        defaultMessage: 'There are many ways you can reduce your premium whilst still maintaining a great level of cover.'
    },
    HealthQ4A2: {
        id: 'cep.faqPage.generalSection.topics.HealthQ4A2',
        defaultMessage: 'Our 4-Week Wait and Guided Care options will give you a lower premium when selected. Plus, you can opt to increase the excess you have to pay if you make a claim which helps to reduce your overall premium without affecting your chosen level of cover.'
    },
    HealthQ4A3: {
        id: 'cep.faqPage.generalSection.topics.HealthQ4A3',
        defaultMessage: 'Take a look at &lt;a href="https://www.saga.co.uk/health-insurance/options-to-improve-your-cover#anchor_Optionstoreducepremium"&gt;options to reduce your premium&lt;/a&gt; to find out more.'
    },
    HealthQ5: {
        id: 'cep.faqPage.generalSection.topics.HealthQ5',
        defaultMessage: 'How do I renew my policy?'
    },
    HealthQ5A1: {
        id: 'cep.faqPage.generalSection.topics.HealthQ5A1',
        defaultMessage: 'We will contact you by post or email at least 21-days prior to the date your policy is due for renewal.'
    },
    HealthQ5A2: {
        id: 'cep.faqPage.generalSection.topics.HealthQ5A2',
        defaultMessage: 'You can renew your policy by calling {phoneNumber}. We are here to help.'
    },
    HealthQ5A3: {
        id: 'cep.faqPage.generalSection.topics.HealthQ5A3',
        defaultMessage: '&lt;b&gt;Opening hours&lt;/b&gt;'
    },
    HealthQ5A4: {
        id: 'cep.faqPage.generalSection.topics.HealthQ5A4',
        defaultMessage: '&lt;b&gt;Monday - Friday&lt;/b&gt; 8.30am-7pm'
    },
    HealthQ5A5: {
        id: 'cep.faqPage.generalSection.topics.HealthQ5A5',
        defaultMessage: '&lt;b&gt;Saturday&lt;/b&gt; 9am to 1pm'
    },
    HealthQ5A6: {
        id: 'cep.faqPage.generalSection.topics.HealthQ5A6',
        defaultMessage: '&lt;b&gt;Sunday&lt;/b&gt; CLOSED'
    },
    HealthQ5A7: {
        id: 'cep.faqPage.generalSection.topics.HealthQ5A7',
        defaultMessage: 'If you need to get in touch with us or for any other reason, please visit our &lt;a href="https://www.saga.co.uk/contact-us/insurance"&gt;contact us page&lt;/a&gt;.'
    },
    HealthQ5A8: {
        id: 'cep.faqPage.generalSection.topics.HealthQ5A8',
        defaultMessage: 'If you pay by Direct Debit, your policy will automatically renew without you having to do anything.'
    },
    HealthQ6: {
        id: 'cep.faqPage.generalSection.topics.HealthQ6',
        defaultMessage: 'Why has my renewal premium increased?'
    },
    HealthQ6A1: {
        id: 'cep.faqPage.generalSection.topics.HealthQ6A1',
        defaultMessage: 'Like other health insurance providers, we regularly review our policies and their cost to ensure that we can continue to give you fast access to diagnosis and treatment. There are a number of factors taken into account when calculating your renewal price, including:'
    },
    HealthQ6A2: {
        id: 'cep.faqPage.generalSection.topics.HealthQ6A2',
        defaultMessage: 'Increased use of health insurance'
    },
    HealthQ6A3: {
        id: 'cep.faqPage.generalSection.topics.HealthQ6A3',
        defaultMessage: 'There are several factors that can affect the price of your policy. The increase in the number of health insurance claims and the overall cost is what impacts our pricing the most. The health service is fighting against significant pressures and NHS staff are coping with extensive challenges every day. As a result, more customers are turning to us to use the Saga GP Service and to get results quickly. There are diagnostic delays even for serious conditions and long waiting lists to treat joint and muscle pain. The government\'s independent review of the NHS, states that as of June 2024, more than 1 million people were waiting for community services, and 345,000 referrals were waiting for first contact with mental health services. All this means that private health insurance customers are more likely to use their cover to receive prompt treatment for non-urgent operations such as joint replacements or cataract surgery. In addition, the cost of medical inflation, which includes the price of medical advancement, staff and services may also affect your premium.'
    },
    HealthQ6A4: {
        id: 'cep.faqPage.generalSection.topics.HealthQ6A4',
        defaultMessage: 'Medical advances'
    },
    HealthQ6A5: {
        id: 'cep.faqPage.generalSection.topics.HealthQ6A5',
        defaultMessage: 'New drug therapies, treatments and procedures are becoming increasingly expensive and as a result some may not be available on the NHS. Health insurance generally gives patients access to more expensive treatment options if they\'re proven to be effective, and this again leads to increased use of health cover and increased costs for us.'
    },
    HealthQ6A6: {
        id: 'cep.faqPage.generalSection.topics.HealthQ6A6',
        defaultMessage: 'Age-related changes'
    },
    HealthQ6A7: {
        id: 'cep.faqPage.generalSection.topics.HealthQ6A7',
        defaultMessage: 'As people grow older, they are more likely to require medical treatment, so this is also reflected in our renewal prices.'
    },
    HealthQ6A8: {
        id: 'cep.faqPage.generalSection.topics.HealthQ6A8',
        defaultMessage: 'Your own Claims'
    },
    HealthQ6A9: {
        id: 'cep.faqPage.generalSection.topics.HealthQ6A9',
        defaultMessage: 'Your premium could also be affected if you make a claim, which reduces your No Claim Discount. Saga policies begin with a No Claim Discount that can increase to 60% over time, but each time you claim your discount is reduced until you reach zero. You can find full details in your Policy Book. However, for an additional payment and subject to your recent claims history, you can take advantage of our optional No Claim Discount protection, which allows you to make one claim without reducing your discount.'
    },
    TravelQ1: {
        id: 'cep.faqPage.generalSection.topics.TravelQ1',
        defaultMessage: 'Should I choose an annual or single trip policy?'
    },
    TravelQ1A1: {
        id: 'cep.faqPage.generalSection.topics.TravelQ1A1',
        defaultMessage: 'If you are likely to be taking more than one trip a year or you are travelling for more than 30 consecutive days then you may find that opting for one of our annual multi-trip travel insurance policies is more cost effective than taking out a separate single trip policy each time you travel.'
    },
    TravelQ1A2: {
        id: 'cep.faqPage.generalSection.topics.TravelQ1A2',
        defaultMessage: 'The advantage of annual multi-trip insurance is that cancellation cover is already in place should you want to go on a last minute holiday or city break.'
    },
    TravelQ1A3: {
        id: 'cep.faqPage.generalSection.topics.TravelQ1A3',
        defaultMessage: 'If you only take the occasional trip, whether in the UK or overseas, you may find a single trip policy more suitable. Our single trip travel insurance is suitable for trips up to 120 days in length, or 180 days for trips in Europe, and covers cancellations (option to remove cover if not required), medical expenses and much more.'
    },
    TravelQ2: {
        id: 'cep.faqPage.generalSection.topics.TravelQ2',
        defaultMessage: 'When should I start my insurance policy?'
    },
    TravelQ2A1: {
        id: 'cep.faqPage.generalSection.topics.TravelQ2A1',
        defaultMessage: 'With a Saga Travel Insurance policy, cancellation cover starts from the date you take out the policy or book the trip. In the unfortunate event that you have to cancel your holiday, our policies can offer up to £20,000 per person Cancellation cover. Maintaining continuous cover with an annual policy could give you the freedom to book last minute trips.'
    },
    TravelQ3: {
        id: 'cep.faqPage.generalSection.topics.TravelQ3',
        defaultMessage: 'Why do I have to provide my medical details to get a quotation?'
    },
    TravelQ3A1: {
        id: 'cep.faqPage.generalSection.topics.TravelQ3A1',
        defaultMessage: 'At Saga we offer comprehensive cover to suit your needs when travelling. To enable us to do this we require details of your medical health so that we can assess whether we can offer insurance to suit your needs.'
    },
    TravelQ3A2: {
        id: 'cep.faqPage.generalSection.topics.TravelQ3A2',
        defaultMessage: 'If you became ill whilst away without appropriate cover or without disclosing your pre-existing medical condition(s), this could lead to complications should you need to make a claim.'
    },
    TravelQ4: {
        id: 'cep.faqPage.generalSection.topics.TravelQ4',
        defaultMessage: 'Do I need travel insurance in European Union Countries?'
    },
    TravelQ4A1: {
        id: 'cep.faqPage.generalSection.topics.TravelQ4A1',
        defaultMessage: 'Yes, the European Health Insurance Card (EHIC) or Global Health Insurance Card (GHIC) is not a substitute for travel insurance – it is complementary to it. An EHIC or GHIC does not cover you for all the medical costs that you can incur or for repatriation, lost baggage or cancellations.'
    },
    TravelQ5: {
        id: 'cep.faqPage.generalSection.topics.TravelQ5',
        defaultMessage: 'How can I cancel my policy?'
    },
    TravelQ5A1: {
        id: 'cep.faqPage.generalSection.topics.TravelQ5A1',
        defaultMessage: 'You have the right to cancel up to 14 days from the date your policy commences, or the date on which you receive your policy documentation, whichever is the later. You will receive a full refund except in the following circumstances:'
    },
    TravelQ5A2: {
        id: 'cep.faqPage.generalSection.topics.TravelQ5A2',
        defaultMessage: 'Your trip has commenced.'
    },
    TravelQ5A3: {
        id: 'cep.faqPage.generalSection.topics.TravelQ5A3',
        defaultMessage: 'You have made or are intending to make a claim. No refund will be given or we will recover the monies paid to you in settlement of the claim before refunding the premium paid.'
    },
    TravelQ5A4: {
        id: 'cep.faqPage.generalSection.topics.TravelQ5A4',
        defaultMessage: 'Your holiday return date is within one month of the commencement of your policy. No refund will be given. (Saga Select policies only)'
    },
    TravelQ5A5: {
        id: 'cep.faqPage.generalSection.topics.TravelQ5A5',
        defaultMessage: 'After the statutory cooling-off period you may cancel the policy at any time by contacting us, but no refund of premium will be available. However, discretion may be exercised in exceptional circumstances to provide a refund for unused cover, those exceptional circumstances being bereavement or an unexpected change to your policy resulting in us being unable to continue covering you. The unused premium will be calculated on a sliding scale basis which is available on request.'
    },
    TravelQ5A6: {
        id: 'cep.faqPage.generalSection.topics.TravelQ5A6',
        defaultMessage: 'Full Terms and Conditions can be found in our Policy Booklets &lt;a href="https://www.saga.co.uk/insurance/travel-insurance/policy-documents"&gt;here&lt;/a&gt;'
    },
    TravelQ6: {
        id: 'cep.faqPage.generalSection.topics.TravelQ6',
        defaultMessage: 'Am I covered if I travel against FCDO advice?'
    },
    TravelQ6A1: {
        id: 'cep.faqPage.generalSection.topics.TravelQ6A1',
        defaultMessage: 'If you choose to travel to a country where the FCDO has advised against &lt;b&gt;all travel&lt;/b&gt;, your Saga Travel Insurance policy will not be valid for this trip.'
    },
    TravelQ6A2: {
        id: 'cep.faqPage.generalSection.topics.TravelQ6A2',
        defaultMessage: 'If you travel to a country where the FCDO has advised against &lt;b&gt;all but essential travel&lt;/b&gt;, for a non-essential reason, you\'ll have no cover in place for any policy section if the reason for your claim is related to why the FCDO advice is in place.'
    },
    TravelQ7: {
        id: 'cep.faqPage.generalSection.topics.TravelQ7',
        defaultMessage: 'Is Saga part of the Money Helper travel insurance directory?'
    },
    TravelQ7A1: {
        id: 'cep.faqPage.generalSection.topics.TravelQ7A1',
        defaultMessage: 'Yes, Saga is listed on the Money Helper Travel Adviser Directory as a company that may be able to help if you have a serious medical condition. You can find out more about this service and view the full directory by visiting the &lt;a href="https://www.moneyhelper.org.uk/en/everyday-money/insurance/travel-insurance-directory?source=mas"&gt;Travel Insurance Directory&lt;/a&gt;.'
    },
    TravelQ8: {
        id: 'cep.faqPage.generalSection.topics.TravelQ8',
        defaultMessage: 'Are there any age limits?'
    },
    TravelQ8A1: {
        id: 'cep.faqPage.generalSection.topics.TravelQ8A1',
        defaultMessage: 'Policyholders must be aged 50 or over. There is no upper age limit and other travellers added to your policy can be of any age.'
    },
    TravelQ9: {
        id: 'cep.faqPage.generalSection.topics.TravelQ9',
        defaultMessage: 'Do I have to book my holiday through Saga? '
    },
    TravelQ9A1: {
        id: 'cep.faqPage.generalSection.topics.TravelQ9A1',
        defaultMessage: 'No, we can offer cover no matter who you book your holiday with.'
    },
    TravelQ10: {
        id: 'cep.faqPage.generalSection.topics.TravelQ10',
        defaultMessage: 'Do you cover one-way trips?'
    },
    TravelQ10A1: {
        id: 'cep.faqPage.generalSection.topics.TravelQ10A1',
        defaultMessage: 'No, Saga only covers round trips that start in and return to the United Kingdom.'
    },
    TravelQ11: {
        id: 'cep.faqPage.generalSection.topics.TravelQ11',
        defaultMessage: 'I live outside the UK, can I get travel insurance from Saga?'
    },
    TravelQ11A1: {
        id: 'cep.faqPage.generalSection.topics.TravelQ11A1',
        defaultMessage: 'Unfortunately we would not be able to provide you with cover - our policies only cover UK residents.'
    },
    TravelQ11A2: {
        id: 'cep.faqPage.generalSection.topics.TravelQ11A2',
        defaultMessage: 'We define UK residents as:'
    },
    TravelQ11A3: {
        id: 'cep.faqPage.generalSection.topics.TravelQ11A3',
        defaultMessage: 'Your home address, which is your main address, should be in the UK (England, Scotland, Wales, Northern Ireland, Channel Islands and the Isle of Man) and'
    },
    TravelQ11A4: {
        id: 'cep.faqPage.generalSection.topics.TravelQ11A4',
        defaultMessage: 'You should be registered with a General Practitioner in the UK.'
    },
    TravelQ12: {
        id: 'cep.faqPage.generalSection.topics.TravelQ12',
        defaultMessage: 'Will my travel agent accept a Saga Travel Insurance policy?'
    },
    TravelQ12A1: {
        id: 'cep.faqPage.generalSection.topics.TravelQ12A1',
        defaultMessage: 'Yes, it is not compulsory to take out the insurance offered by travel agents or tour operators and you have the right to shop elsewhere if you so wish. However, they may ask you to prove that you have sufficient cover for the trip in question by asking for your policy number and cover details.'
    },
    TravelQ13: {
        id: 'cep.faqPage.generalSection.topics.TravelQ13',
        defaultMessage: 'Will friends and family be covered when travelling without me?'
    },
    TravelQ13A1: {
        id: 'cep.faqPage.generalSection.topics.TravelQ13A1',
        defaultMessage: 'Yes, if they are listed on an &lt;a href="https://www.saga.co.uk/insurance/travel-insurance/annual-travel-insurance"&gt;annual multi-trip policy&lt;/a&gt; they can travel independently and still benefit from the same cover as you. This does not apply to single trip policies.'
    },
    TravelQ13A2: {
        id: 'cep.faqPage.generalSection.topics.TravelQ13A2',
        defaultMessage: 'Please note that insured persons under 16 years of age will only be covered when they are travelling with an adult named on your policy Schedule.'
    },
    TravelQ14: {
        id: 'cep.faqPage.generalSection.topics.TravelQ14',
        defaultMessage: 'Can I change the policy excess?'
    },
    TravelQ14A1: {
        id: 'cep.faqPage.generalSection.topics.TravelQ14A1',
        defaultMessage: 'Saga Travel Insurance customers with our Standard or Plus cover levels can select from 4 levels of excess to pay in the event of a claim:'
    },
    TravelQ14A2: {
        id: 'cep.faqPage.generalSection.topics.TravelQ14A2',
        defaultMessage: '£0'
    },
    TravelQ14A3: {
        id: 'cep.faqPage.generalSection.topics.TravelQ14A3',
        defaultMessage: '£70'
    },
    TravelQ14A4: {
        id: 'cep.faqPage.generalSection.topics.TravelQ14A4',
        defaultMessage: '£150'
    },
    TravelQ14A5: {
        id: 'cep.faqPage.generalSection.topics.TravelQ14A5',
        defaultMessage: '£250'
    },
    TravelQ14A6: {
        id: 'cep.faqPage.generalSection.topics.TravelQ14A6',
        defaultMessage: 'If you have opted for an excess, you will only have to pay one excess per incident, irrespective of the number of sections claimed or insured persons involved.'
    },
    TravelQ14A7: {
        id: 'cep.faqPage.generalSection.topics.TravelQ14A7',
        defaultMessage: 'Please see our &lt;a href="https://www.saga.co.uk/travel-insurance#anchor_Coverlevels"&gt;summary of cover&lt;/a&gt; section for details of when an excess is applicable.'
    },
    TravelQ15: {
        id: 'cep.faqPage.generalSection.topics.TravelQ15',
        defaultMessage: 'Can I remove money and baggage cover to reduce my premium?'
    },
    TravelQ15A1: {
        id: 'cep.faqPage.generalSection.topics.TravelQ15A1',
        defaultMessage: 'No, our policy covers money and baggage as standard within the overall price of the policy.  However, we do offer a range of cover levels to suit different needs. &lt;a href="https://www.saga.co.uk/travel-insurance"&gt;Click here&lt;/a&gt; to see our range of travel insurance for the over 50s.'
    },
    TravelQ16: {
        id: 'cep.faqPage.generalSection.topics.TravelQ16',
        defaultMessage: 'Am I covered for leisure activities and sports?'
    },
    TravelQ16A1: {
        id: 'cep.faqPage.generalSection.topics.TravelQ16A1',
        defaultMessage: 'Yes, our policy covers over 80 different activities as standard. See our &lt;a href="https://www.saga.co.uk/insurance/travel-insurance/leisure-activities"&gt;leisure and winter sports activities&lt;/a&gt; for a list.'
    },
    TravelQ16A2: {
        id: 'cep.faqPage.generalSection.topics.TravelQ16A2',
        defaultMessage: 'If there are activities you intend to participate in that are not listed, please call us to confirm whether cover is provided.'
    },
    TravelQ16A3: {
        id: 'cep.faqPage.generalSection.topics.TravelQ16A3',
        defaultMessage: 'This insurance does not cover you while you are taking part in:'
    },
    TravelQ16A4: {
        id: 'cep.faqPage.generalSection.topics.TravelQ16A4',
        defaultMessage: 'any organised team or contact sport not listed'
    },
    TravelQ16A5: {
        id: 'cep.faqPage.generalSection.topics.TravelQ16A5',
        defaultMessage: 'any sport or competition as a professional'
    },
    TravelQ16A6: {
        id: 'cep.faqPage.generalSection.topics.TravelQ16A6',
        defaultMessage: 'any activity where you are competing in or practising for speed or time trials, sprints or racing of any kind, except as otherwise mentioned within the Policy Booklet.'
    },
    TravelQ17: {
        id: 'cep.faqPage.generalSection.topics.TravelQ17',
        defaultMessage: 'Can I extend my Annual policy for trips over 45 days?'
    },
    TravelQ17A1: {
        id: 'cep.faqPage.generalSection.topics.TravelQ17A1',
        defaultMessage: 'We are able to extend up to 60 days per trip if you are travelling to the U.S.A, Canada, Mexico or any Caribbean Islands. If you opt for a cover excluding these countries, we are able to extend your cover up to 90 days per trip (Annual trip policies allow for a maximum of 180 days travel per policy year). Alternatively, our single trip travel insurance is suitable for trips up to 120 days in length, or 180 days for trips in Europe.'
    },
    TravelQ18: {
        id: 'cep.faqPage.generalSection.topics.TravelQ18',
        defaultMessage: 'Is it illegal to travel without travel insurance?'
    },
    TravelQ18A1: {
        id: 'cep.faqPage.generalSection.topics.TravelQ18A1',
        defaultMessage: 'Taking out travel insurance before you go abroad is not a legal requirement, although some tour operators may insist that you have evidence of a valid travel insurance policy. However, it does protect you against medical treatment costs which are much higher than we pay in the UK, as well as providing cancellation cover, and other benefits. Not to mention the peace of mind knowing you are covered against the unexpected whilst abroad.'
    },
    TravelQ19: {
        id: 'cep.faqPage.generalSection.topics.TravelQ19',
        defaultMessage: 'How do I contact Saga?'
    },
    TravelQ19A1: {
        id: 'cep.faqPage.generalSection.topics.TravelQ19A1',
        defaultMessage: 'If you\'re a Saga Travel Insurance policyholder and you need to make changes to your policy, you can contact us on 0800 056 9200 or 01843 343 203.'
    },
    TravelQ19A2: {
        id: 'cep.faqPage.generalSection.topics.TravelQ19A2',
        defaultMessage: '&lt;b&gt;Opening hours&lt;/b&gt;'
    },
    TravelQ19A3: {
        id: 'cep.faqPage.generalSection.topics.TravelQ19A3',
        defaultMessage: '&lt;b&gt;Monday - Friday&lt;/b&gt; 8:30am - 7:00pm'
    },
    TravelQ19A4: {
        id: 'cep.faqPage.generalSection.topics.TravelQ19A4',
        defaultMessage: '&lt;b&gt;Saturday&lt;/b&gt; 8:30am - 5:00pm'
    },
    TravelQ19A5: {
        id: 'cep.faqPage.generalSection.topics.TravelQ19A5',
        defaultMessage: '&lt;b&gt;Sunday&lt;/b&gt; CLOSED'
    },
    TravelQ19A6: {
        id: 'cep.faqPage.generalSection.topics.TravelQ19A6',
        defaultMessage: 'If you need to get in touch with us for any other reason, please &lt;a href="https://www.saga.co.uk/insurance/contact-us"&gt;visit our contact us page&lt;/a&gt;.'
    },
});
